/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import Cookie from 'universal-cookie';

const cookie = new Cookie();

class CookiesService {
  get(key) {
    //Get saved data from sessionStorage
    ////let data = window.sessionStorage.getItem(key);

    return window.sessionStorage.getItem(key);
  }

  set(key, value, options) {
    //Save data to sessionStorage
    window.sessionStorage.setItem(key, value);
  }

  remove(key) {
    //Remove saved data from sessionStorage
    window.sessionStorage.removeItem(key);
  }

  clear() {
    //Remove all saved data from sessionStorage
    window.sessionStorage.clear();
  }
}

export default new CookiesService();
